import { GiftPdpState } from '@ff-scene-plugins/gift-redux/store';
import { selectApiStatusForInputs } from '../_redux-inputs';

export const getProjectExportStatus = (state: GiftPdpState) => {

    const statuses = [
        selectApiStatusForInputs(state),
        state.fonts.loadStatus,
        state.projectLoading.loadStatus
    ];

    if (statuses.every(s => s === 'ready')) {
        return 'ready';
    } else if (statuses.includes('error')) {
        return 'error';
    } else {
        return 'pending';
    }
};